import styled from 'styled-components';
import { SemanticUI } from '@iterable/deprecated_react_components';

export const StyledSemanticDropdown = styled(SemanticUI.Dropdown)`
  &&& {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    max-width: 50% !important;
    &:hover {
      z-index: 1;
    }
    + div {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      max-width: 50% !important;

      &.label.ui {
        display: flex;
        align-items: center;
        margin-left: 0;
      }
    }
  }
`;

export const UnitDropdownContainer = styled.div`
  display: flex;
  align-items: center;

  [data-test='append-label'] {
    height: 100%;
  }
`;
